import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MyImage from "../reactLazyLoading";

interface CarCardProps {
  car: any;
  selectedLang: string;
  index: number;
}

const CarCard: React.FC<CarCardProps> = ({ car, selectedLang, index }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-50px" });

  const cardVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.6, ease: "easeOut", delay: index * 0.3 },
    },
    exit: {
      opacity: 0,
      transition: { duration: 0.6, ease: "easeIn", delay: (2 - index) * 0.3 },
    },
  };

  return (
    <motion.div
      ref={ref}
      className="car-card"
      variants={cardVariants}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      exit="exit"
      layout
      onClick={() => navigate(`/${selectedLang}/cars/${car.id}`)}
    >
      <div className="car-image-container">
        <MyImage src={car.imageUrl} className="car-image" />
        <div className="car-image-overlay">
          <button className="car-button">
            {t("carDetails.discoverButton")} →
          </button>
        </div>
      </div>

      <div className="car-details">
        <h2 className="car-title">{car.title}</h2>
        <h3 className="car-subtitle">{car.subtitle}</h3>
        <p className="car-info">
          {t("carDetails.year")}: {car.year} | {car.mileage}
        </p>
        <p className="car-price">{car.translations[selectedLang].price}</p>
      </div>
    </motion.div>
  );
};

export default CarCard;
